import { render, staticRenderFns } from "./UnitViewModal.vue?vue&type=template&id=b72e8592&scoped=true"
import script from "./UnitViewModal.vue?vue&type=script&lang=js"
export * from "./UnitViewModal.vue?vue&type=script&lang=js"
import style0 from "./UnitViewModal.vue?vue&type=style&index=0&id=b72e8592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72e8592",
  null
  
)

export default component.exports